import { NavLink } from "react-router-dom";
import { Menu, Search, ShieldCheck, History } from "lucide-react";
import { useOrders } from "@/lib/OrdersContext";
import { useAuth } from "@/lib/AuthContext";
import { Notifications } from "@/components/Notifications";

export const Topbar = ({ onMenu }) => {
  const { search, setSearch } = useOrders();
  const { profile } = useAuth();
  return (
    <header className="sticky top-0 z-20 flex items-center gap-3 border-b border-white/5 bg-[#09090b]/80 px-4 py-3 backdrop-blur-xl md:px-8">
      <button data-testid="topbar-menu-btn" onClick={onMenu} className="text-zinc-400 lg:hidden"><Menu className="h-5 w-5" /></button>
      <div className="relative ml-auto min-w-0 flex-1 sm:max-w-md">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
        <input
          data-testid="global-search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar cliente, matrícula, modelo…"
          className="h-10 w-full rounded-lg border border-white/10 bg-white/[0.03] pl-9 pr-3 text-sm outline-none transition-colors placeholder:text-zinc-500 focus:border-[var(--gold)]"
        />
      </div>
      <NavLink to="/historial" data-testid="delivered-history-btn" aria-label="Historial de Entregados"
        className={({ isActive }) => `flex h-10 shrink-0 items-center gap-2 rounded-lg border px-3 text-sm font-semibold transition-colors duration-200 ${isActive ? "border-[var(--gold)] bg-[var(--gold-soft)] text-[var(--gold)]" : "border-white/10 bg-white/[0.03] text-zinc-300 hover:border-[var(--gold)] hover:text-[var(--gold)]"}`}>
        <History className="h-[18px] w-[18px]" /><span className="hidden md:inline">Historial de Entregados</span>
      </NavLink>
      <Notifications />
      {profile?.es_admin === true && (
        <NavLink to="/activaciones" data-testid="mobile-activaciones-link" aria-label="Activaciones"
          className={({ isActive }) => `flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border lg:hidden ${isActive ? "border-[var(--gold)] bg-[var(--gold-soft)] text-[var(--gold)]" : "border-white/10 bg-white/[0.03] text-zinc-300"}`}>
          <ShieldCheck className="h-[18px] w-[18px]" />
        </NavLink>
      )}
    </header>
  );
};
